import { NotificationsActions } from "./actions";
import { INotificationPayloadData } from "./notificationsReducer";

export enum NotificationVariants {
    DEFAULT = 'default',
    ERROR = 'error',
    SUCCESS = 'success',
    WARNING = 'warning',
    INFO = 'info'
}

interface InotificationParams {
    dispatch: any,
    title: string,
    description?: string,
    variant?: NotificationVariants
}




export function notify(params: InotificationParams) {
    const payloadData: INotificationPayloadData = {
        id: Date.now(),
        title: params.title,
        description: params.description || '',
        variant: params.variant || 'default'
    }
    params.dispatch({ type: NotificationsActions.ADD_NOTIFICATION, payload: payloadData });

}